export type MaintenanceConfig = {
  enabled: boolean;
  endAt: Date | null;
  message: string | null;
};

export type CountdownParts = {
  totalMs: number;
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  isExpired: boolean;
};

const ISO_WITH_TIMEZONE =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,9})?(?:Z|[+-]\d{2}:\d{2})$/;

export function parseMaintenanceEnd(input?: string): Date | null {
  const trimmed = input?.trim();
  if (!trimmed) {
    return null;
  }

  if (!ISO_WITH_TIMEZONE.test(trimmed)) {
    console.warn(
      "[maintenance] VITE_APP_MAINTENANCE_END must be ISO 8601 with explicit timezone:",
      trimmed,
    );
    return null;
  }

  const parsed = new Date(trimmed);
  if (Number.isNaN(parsed.getTime())) {
    console.warn("[maintenance] Invalid VITE_APP_MAINTENANCE_END:", trimmed);
    return null;
  }

  return parsed;
}

export function getMaintenanceConfig(): MaintenanceConfig {
  const enabled = import.meta.env.VITE_APP_MAINTENANCE_ENABLED === "true";
  const messageRaw = import.meta.env.VITE_APP_MAINTENANCE_MESSAGE;
  const message =
    typeof messageRaw === "string" && messageRaw.trim().length > 0 ? messageRaw.trim() : null;

  return {
    enabled,
    endAt: parseMaintenanceEnd(import.meta.env.VITE_APP_MAINTENANCE_END),
    message,
  };
}

export function getCountdownParts(endAt: Date, now = Date.now()): CountdownParts {
  const totalMs = Math.max(0, endAt.getTime() - now);
  const totalSeconds = Math.floor(totalMs / 1000);

  return {
    totalMs,
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
    isExpired: totalMs === 0,
  };
}
